import axios from 'axios'

export default {
  namespaced: true,

  state : {
    initailShowAgents : false,
    allAgents : [
      // {
      //   name : "John Doe",
      //   country : 'usa',
      //   city : 'Foo-Bar City',
      //   address : "Foo Bar Street 20 Belgrade Montana",
      //   zip: 11090,
      //   province : 'Foo Province',
      //   website: "http://www.google.com",
      //   email: "foo@bar.com",
      //   visibility : true,
      //   phone_number : 123456789,
      //   phone_number2 : 987654321,
      //   lng : -111.197,
      //   lat: 45.7589
      // },
      // {
      //   name : "John Doe Jr",
      //   country : 'usa',
      //   city : 'Foo-Bar City',
      //   address : "Foo Bar Boulivard XXY",
      //   zip: 11090,
      //   email: "foo@bar.com",
      //   province : 'Foo Province',
      //   website: "http://www.google.com",
      //   phone_number : 123456789,
      //   visibility : true,
      //   lng : -100.01,
      //   lat : 41.11
      // },
      // {
      //   name : "John Doe III",
      //   country : 'usa',
      //   city : 'Foo-Bar City',
      //   address : "Foo Bar Boulivard XXY",
      //   zip: 11090,
      //   province : 'Foo Province',
      //   website: "http://www.google.com",
      //   phone_number : 123456789,
      //   visibility : true,
      //   lng : -105.01,
      //   lat : 38.11
      // },
      // {
      //   name : "Michael Jordan",
      //   country : 'usa',
      //   city : 'Foo-Bar City',
      //   address : "Nba Hall of Fame 1993",
      //   zip: 11090,
      //   email: "foo@bar.com",
      //   province : 'Foo Province',
      //   website: "http://www.google.com",
      //   phone_number : 123456789,
      //   phone_number2 : 987654321,
      //   visibility : true,
      //   lng : -111.197,
      //   lat: 48.7589
      // },
      // {
      //   name : "Greg Popovich",
      //   country : 'usa',
      //   city : 'Foo-Bar City',
      //   address : "Nba Hall of Fame 1993",
      //   zip: 11090,
      //   province : 'Foo Province',
      //   website: "http://www.google.com",
      //   phone_number : 123456789,
      //   visibility : true,
      //   lng : -102.01,
      //   lat : 47.11
      // },
      // {
      //   name : "Lary Bird",
      //   country : 'usa',
      //   city : 'Foo-Bar City',
      //   address : "Germinal Street",
      //   zip: 11090,
      //   province : 'Foo Province',
      //   website: "http://www.google.com",
      //   phone_number : 123456789,
      //   visibility : true,
      //   lng : -110.197,
      //   lat: 46.7589
      // },
      // {
      //   name : "Vlade Divac",
      //   country : 'usa',
      //   city : 'Foo-Bar City',
      //   address : "Nba Hall of Fame 1993",
      //   zip: 11090,
      //   province : 'Foo Province',
      //   website: "http://www.google.com",
      //   phone_number : 123456789,
      //   visibility : true,
      //   lng : -81.197,
      //   lat: 39.7589
      // },
      // {
      //   name : "Nikola Jokic",
      //   country : 'usa',
      //   city : 'Foo-Bar City',
      //   address : "Nba Hall of Fame 2020",
      //   zip: 11090,
      //   province : 'Foo Province',
      //   website: "http://www.google.com",
      //   visibility : false,
      //   phone_number : 123456789,
      //   lng : -107.197,
      //   lat: 46.7589
      // },
      // {
      //   name : "Jacque The Canadian",
      //   country : 'cad',
      //   city : 'A Canadian City',
      //   address : "A Canadian Address 2020",
      //   zip: 11090,
      //   province : 'Foo Province',
      //   website: "http://www.google.com",
      //   visibility : false,
      //   phone_number : 123456789,
      //   lng : -140.293373,
      //   lat: 62.7589
      // },
      // {
      //   name : "Justin Trudau",
      //   country : 'cad',
      //   city : 'A Canadian City',
      //   address : "A Canadian Address 2020",
      //   zip: 11090,
      //   province : 'Foo Province',
      //   website: "http://www.google.com",
      //   visibility : true,
      //   phone_number : 123456789,
      //   lng : -133.293373,
      //   lat: 54.7589
      // }
    ],
    mapStyles: [
      // { elementType: "geometry", stylers: [{ color: "#F5F5F5" }] },
      // { elementType: "labels.text.stroke", stylers: [{ color: "#F5F5F5" }] },
      // { elementType: "labels.text.fill", stylers: [{ color: "#999999" }] },
      // {
      //   featureType: "administrative.locality",
      //   elementType: "labels.text.fill",
      //   stylers: [{ color: "#616161" }],
      // },
      // {
      //   featureType: "poi",
      //   elementType: "labels.text.fill",
      //   stylers: [{ color: "#d59563" }],
      // },
      // {
      //   featureType: "poi.park",
      //   elementType: "geometry",
      //   stylers: [{ color: "#E5E5E5" }],
      // },
      // {
      //   featureType: "poi.park",
      //   elementType: "labels.text.fill",
      //   stylers: [{ color: "#6b9a76" }],
      // },
      // {
      //   featureType: "road",
      //   elementType: "geometry",
      //   stylers: [{ color: "#fff" }],
      // },
      // {
      //   featureType: "road",
      //   elementType: "geometry.stroke",
      //   stylers: [{ color: "#ffffff" }],
      // },
      // {
      //   featureType: "road",
      //   elementType: "labels.text.fill",
      //   stylers: [{ color: "#9ca5b3" }],
      // },
      // {
      //   featureType: "road.highway",
      //   elementType: "geometry",
      //   stylers: [{ color: "#DBDBDB" }],
      // },
      // {
      //   featureType: "road.highway",
      //   elementType: "geometry.stroke",
      //   stylers: [{ color: "#1f2835" }],
      // },
      // {
      //   featureType: "road.highway",
      //   elementType: "labels.text.fill",
      //   stylers: [{ color: "#f3d19c" }],
      // },
      // {
      //   featureType: "transit",
      //   elementType: "geometry",
      //   stylers: [{ color: "#2f3948" }],
      // },
      // {
      //   featureType: "transit.station",
      //   elementType: "labels.text.fill",
      //   stylers: [{ color: "#d59563" }],
      // },
      // {
      //   featureType: "water",
      //   elementType: "geometry",
      //   stylers: [{ color: "#C9C9C9" }],
      // },
      // {
      //   featureType: "water",
      //   elementType: "labels.text.fill",
      //   stylers: [{ color: "#515c6d" }],
      // },
      // {
      //   featureType: "water",
      //   elementType: "labels.text.stroke",
      //   stylers: [{ color: "#C9C9C9" }],
      // },
    ],

    circleParams : {
      strokeColor: "rgb(255, 192, 23, .3)",
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: "rgb(255, 192, 23, .1)",
      fillOpacity: 0.35,
      center: null,
      radius: null, //mile to m
    }
  },

  getters : {
    initailShowAgents : state => state.initailShowAgents,
    allAgents : state => state.allAgents.filter(agent => agent.visibility),
    agentsFromTheCountry : (state) => (country) => state.allAgents.filter(agent => agent.country == country && agent.visibility),
    mapStyles : state => state.mapStyles,
    circleParams : state => state.circleParams
  },

  mutations : {
    /**
     * [add agents to module state]
     * @param {[Array]} agents [array of objects]
     */

    SET_AGENTS : (state, agents) => {
      state.allAgents = agents
    },
    SET_INITIAL_SHOW_AGENTS : (state, value) => {
      state.initailShowAgents = value
    },
    SET_CIRCLE_PARAMS : (state, params) => {
      state.circleParams.center = params.center
      state.circleParams.radius = params.radius
      //
    }
  },

  actions : {
    async loadMapData({commit}){
      try {
          const response = await axios.get('/api/v1/agents');
          commit('SET_AGENTS', response.data.agents)
          commit('SET_INITIAL_SHOW_AGENTS', +response.data.should_show_map_pins_on_init)
      } catch (error) {
        console.log(error)
      }
  }
  }




}
